import { SelectOption } from "rizzui";

export enum EImportTaskStatus {
  Processing = "processing",
  Success = "success",
  Failed = "failed",
  Pending = "pending",
  PartialSuccess = "partial_success",
}

export enum EImportErrorCode {
  UNMAPPED_PROJECT = "UNMAPPED_PROJECT",
  INVALID_DATA = "INVALID_DATA",
  DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION",
}

export enum EImportErrorStatus {
  PENDING = "PENDING",
  RESOLVED = "RESOLVED",
  SKIPPED = "SKIPPED",
}

export enum EImportType {
  Project = "project",
  Category = "category",
  UnitType = "unit-type",
  FloorPlan = "floor-plan",
  UnitTransaction = "unit-transaction",
  DirectCommission = "direct-commission",
  Mortgage = "mortgage",
  UpdateShowFlatProject = "update_showflat_project",
  ResidentialTransaction = "residential-transaction",
}

export const E_IMPORT_DATA = Object.freeze({
  MAIN: "/import-data",
  PROJECT: "/import-data/project",
  FLOOR_PLAN: "/import-data/floor-plan",
  PROJECT_TYPE: "/import-data/project-type",
  UNIT_TYPE: "/import-data/unit-type",
  UNIT_TRANSACTION_PROJECT: "/import-data/unit-transaction/project",
  UNIT_TRANSACTION: "/import-data/unit-transaction",
  DIRECT_COMMISSION: "/import-data/direct-commission",
  MORTGAGE: "/import-data/mortgage",
  UPDATE_SHOWFLAT_PROJECT: "/import-data/update-showflat-project",
  RESIDENTIAL_TRANSACTION: "/import-data/residential-transaction",
  TASK_ID: (id: string = ":id") => `/import-data/${id}`,
  TASK_ERRORS: (id: string = ":id") => `/import-data/${id}/errors`,
  UNMAPPED_PROJECTS: (id: string = ":id") =>
    `/import-data/${id}/errors/unmapped-projects`,
  MAP_PROJECT: "/import-data/project-alias/map-and-reprocess",
});

export const IMPORT_TYPE_LABEL = Object.freeze({
  [EImportType.Category]: "Project type (Category)",
  [EImportType.Project]: "Project Detail",
  [EImportType.UnitType]: "Unit Type",
  [EImportType.FloorPlan]: "Floorplan",
  [EImportType.UnitTransaction]: "Unit Transaction",
  [EImportType.DirectCommission]: "Direct Commission",
  [EImportType.Mortgage]: "Mortgage",
  [EImportType.UpdateShowFlatProject]: "Update ShowFlat Project",
  [EImportType.ResidentialTransaction]: "Residential Transaction",
});

export const ErrorStatusColors = {
  [EImportErrorStatus.PENDING]: "text-amber-600 bg-amber-50 border-amber-200",
  [EImportErrorStatus.RESOLVED]: "text-emerald-600 bg-emerald-50 border-emerald-200",
  [EImportErrorStatus.SKIPPED]: "text-gray-500 bg-gray-50 border-gray-200",
};

export const StatusColors = {
  [EImportTaskStatus.Processing]: "text-sky-600",
  [EImportTaskStatus.Success]: "text-green-700",
  [EImportTaskStatus.Failed]: "text-red-600",
  [EImportTaskStatus.Pending]: "text-black",
  [EImportTaskStatus.PartialSuccess]: "text-amber-600",
};

export const IMPORT_TYPE_OPTIONS: SelectOption[] = [
  { label: "Project type", value: "project-type" },
  { label: "Unit type", value: "unit-type" },
  { label: "Project", value: "project" },
  { label: "Direct commission", value: "direct-commission" },
  // { label: "Floorplan", value: "floor-plan" },
  {
    label: "Unit transaction",
    value: "unit-transaction",
  },
  {
    label: "Unit transaction (with project)",
    value: "unit-transaction/project",
  },
  { label: "Mortgage", value: "mortgage" },
  { label: "Update ShowFlat Project", value: "update_showflat_project" },
  { label: "Residential Transaction", value: "residential-transaction" },
];
